export const emailRegex = new RegExp('^.+@.+\\..{2,}$');